"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9313],{

/***/ 66826:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ UnskipButton_UnskipButton)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./src/components/inputs/Button/Button.tsx + 6 modules
var Button = __webpack_require__(23796);
// EXTERNAL MODULE: ./src/compositions/buttons/UnskipButton/util/useUnskipSubscription.ts + 2 modules
var useUnskipSubscription = __webpack_require__(86299);
;// CONCATENATED MODULE: ./src/compositions/buttons/UnskipButton/messages.ts
/* harmony default export */ const messages = ({
    title: {
        en: "Cancel your {monthsDuration, select, 0 {one month} 1 {one month} 2 {two months} 3 {three months} other {# months}} break"
    }
});

;// CONCATENATED MODULE: ./src/compositions/buttons/UnskipButton/UnskipButton.tsx






const UnskipButton = (props)=>{
    const { size = 56, width, style = "primary", title, placement, fullWidthOnMobile, "data-testid": dataTestId = "unskipButton", isRedirectRequired, onSuccess } = props;
    const { monthsDuration, handleUnskipSubscription, isSubmitting, isFetching } = (0,useUnskipSubscription/* default */.Z)({
        placement,
        isRedirectRequired
    });
    const buttonTitle = (0,react.useMemo)(()=>title || {
            ...messages.title,
            values: {
                monthsDuration
            }
        }, [
        title,
        monthsDuration
    ]);
    const handleClick = ()=>{
        (0,analytics/* track */.j)("Cancel skip click");
        handleUnskipSubscription().then(()=>{
            if (typeof onSuccess === "function") {
                onSuccess();
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        size: size,
        title: buttonTitle,
        style: style,
        width: width,
        loading: isSubmitting || isFetching,
        fullWidthOnMobile: fullWidthOnMobile,
        onClick: handleClick,
        "data-testid": dataTestId
    });
};
/* harmony default export */ const UnskipButton_UnskipButton = (/*#__PURE__*/react.memo(UnskipButton));


/***/ }),

/***/ 86299:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ util_useUnskipSubscription)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./local_modules/apollo-client/hooks/useMutation.ts + 1 modules
var useMutation = __webpack_require__(41146);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var manager = __webpack_require__(72065);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(91339);
;// CONCATENATED MODULE: ./src/compositions/buttons/UnskipButton/util/unskipSubscription.graphql.ts
const UnskipSubscriptionDocument = {
    "kind": "Document",
    "definitions": [
        {
            "kind": "OperationDefinition",
            "operation": "mutation",
            "name": {
                "kind": "Name",
                "value": "UnskipSubscription"
            },
            "variableDefinitions": [
                {
                    "kind": "VariableDefinition",
                    "variable": {
                        "kind": "Variable",
                        "name": {
                            "kind": "Name",
                            "value": "input"
                        }
                    },
                    "type": {
                        "kind": "NonNullType",
                        "type": {
                            "kind": "NamedType",
                            "name": {
                                "kind": "Name",
                                "value": "SubscriptionUnskipInput"
                            }
                        }
                    }
                }
            ],
            "selectionSet": {
                "kind": "SelectionSet",
                "selections": [
                    {
                        "kind": "Field",
                        "name": {
                            "kind": "Name",
                            "value": "subscriptionUnskip"
                        },
                        "arguments": [
                            {
                                "kind": "Argument",
                                "name": {
                                    "kind": "Name",
                                    "value": "input"
                                },
                                "value": {
                                    "kind": "Variable",
                                    "name": {
                                        "kind": "Name",
                                        "value": "input"
                                    }
                                }
                            }
                        ],
                        "selectionSet": {
                            "kind": "SelectionSet",
                            "selections": [
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "data"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "Field",
                                                "name": {
                                                    "kind": "Name",
                                                    "value": "premiumProductInBatchNotification"
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "product"
                                                            },
                                                            "selectionSet": {
                                                                "kind": "SelectionSet",
                                                                "selections": [
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "id"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "image"
                                                                        }
                                                                    },
                                                                    {
                                                                        "kind": "Field",
                                                                        "name": {
                                                                            "kind": "Name",
                                                                            "value": "upchargePrice"
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    "kind": "Field",
                                    "name": {
                                        "kind": "Name",
                                        "value": "error"
                                    },
                                    "selectionSet": {
                                        "kind": "SelectionSet",
                                        "selections": [
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "SecurityError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "securityErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "UnskipError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "unskipErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "BusinessError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "businessErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                "kind": "InlineFragment",
                                                "typeCondition": {
                                                    "kind": "NamedType",
                                                    "name": {
                                                        "kind": "Name",
                                                        "value": "ServerError"
                                                    }
                                                },
                                                "selectionSet": {
                                                    "kind": "SelectionSet",
                                                    "selections": [
                                                        {
                                                            "kind": "Field",
                                                            "alias": {
                                                                "kind": "Name",
                                                                "value": "serverErrorCode"
                                                            },
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "errorCode"
                                                            }
                                                        },
                                                        {
                                                            "kind": "Field",
                                                            "name": {
                                                                "kind": "Name",
                                                                "value": "message"
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ]
};
// remove fragments duplicates
// @ts-ignore
UnskipSubscriptionDocument["definitions"] = [
    ...new Set(UnskipSubscriptionDocument.definitions)
];
/* harmony default export */ const unskipSubscription_graphql = (UnskipSubscriptionDocument);

;// CONCATENATED MODULE: ./src/compositions/buttons/UnskipButton/util/messages.ts
/* harmony default export */ const messages = ({
    successNotification: {
        title: {
            en: "Success!"
        },
        text: {
            en: "Your subscription has resumed. Modify your next order within 12 hours, before we ship your delivery."
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/buttons/UnskipButton/util/useUnskipSubscription.ts










const useUnskipSubscription = (param)=>{
    let { placement, isRedirectRequired: defaultValue } = param;
    const history = (0,contexts/* useHistory */.k6)();
    const pathname = (0,contexts/* usePathname */.jD)();
    const [submitQuery, { isFetching: isSubmitting }] = (0,useMutation/* default */.Z)(unskipSubscription_graphql, {
        refetchQueries: [
            "Subscription"
        ],
        awaitRefetchQueries: true
    });
    const { subscription, isFetching } = (0,subscription_subscription/* useSubscription */.mU)();
    const monthsDuration = subscription?.activeHold?.monthsDuration;
    const isRedirectRequired = defaultValue ?? pathname !== links/* default */.ZP.profile.subscriptionStatus;
    const handleUnskipSubscription = (0,react.useCallback)(async ()=>{
        try {
            const result = await submitQuery({
                variables: {
                    input: {
                        metadata: {
                            placement
                        }
                    }
                }
            });
            if (result.errors) {
                throw new errors/* GraphQLError */.__(result.errors);
            }
            const { error, data } = result.data.subscriptionUnskip;
            if (error) {
                if (error.__typename === "BusinessError" && error.businessErrorCode === "PAYMENT_METHOD_NOT_FOUND") {
                    history.push(links/* default */.ZP.cardUpdate);
                }
                throw new errors/* UserError */.gK(error);
            }
            const premiumProduct = data?.premiumProductInBatchNotification?.product;
            if (premiumProduct) {
                // TODO display WelcomeBack modal with product - added on 1/26/21 by @mikediam
                return;
            }
            if (isRedirectRequired) {
                history.push(links/* default */.ZP.profile.subscriptionStatus);
            }
            (0,manager/* openNotification */.Ym)("success", messages.successNotification);
        } catch (error) {
            (0,errors/* processError */.wY)(error);
        }
    }, [
        submitQuery,
        placement,
        history,
        isRedirectRequired
    ]);
    return {
        monthsDuration,
        handleUnskipSubscription,
        isSubmitting,
        isFetching
    };
};
/* harmony default export */ const util_useUnskipSubscription = (useUnskipSubscription);


/***/ })

}]);